$.eachComponent('.configurator-links', function(context) {
    $(context).on('change', 'select[name="fk_configurator_wizards"]', function(e) {
        $('input[name=reinit]', $(context).parents('form')).click();
    });
});